import clsx from 'clsx'
import React, { PropsWithChildren } from 'react'

type ThemeWrapperProps = {
  brand: string
  appId?: string
} & PropsWithChildren

export const ThemeWrapper: React.FC<ThemeWrapperProps> = ({ appId, brand, children }) => {
  return (
    <div data-app-id={appId} className={clsx('dbtheme-base', `dbtheme-${brand}`)}>
      {children}
    </div>
  )
}
